import React from 'react'
import withSimpleApi, { WithSimpleApiProps } from '~/decorators/withSimpleApi'
import { CallOnList } from '~/service/CallListManager'
import { ListOnly } from '../calls/List'
import MainContent from '../MainContent'

type ApiDataType = {
  calls: CallOnList[]
}

const Show: React.FC<WithSimpleApiProps<ApiDataType>> = ({ apiData }) => {
  const { calls } = apiData

  return (
    <MainContent>
      <ListOnly items={calls} />
    </MainContent>
  )
}
const ShowWithApi = withSimpleApi(Show)

export default ShowWithApi
